export enum ChecklistItemTypeEnum {
  shopping = 'shopping',
  work = 'work',
  products = 'products',
  cleaning = 'cleaning',
  party = 'party',
  custom = 'custom',
  new = 'new',
}
